import type { ReactNode } from 'react';

import { ToastProvider } from '@/components/shared/Toast';
import { TooltipProvider } from '@/components/ui/tooltip';

/**
 * Feature-scoped provider stack for the authenticated pages: the toast host
 * (mutation feedback, design §16.3) and the tooltip provider the disabled-action
 * rationale needs (§14.5).
 *
 * Mounted by each feature's `routes.tsx` layout element instead of `main.tsx`:
 * the shell files are owned by P1-T2/T4 and must not be edited by feature tasks,
 * while the registry contract lets a feature wrap its own subtree. Only one
 * feature tree is mounted at a time, so exactly one toast host is live.
 */
export function AppShellProviders({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <TooltipProvider delayDuration={150}>{children}</TooltipProvider>
    </ToastProvider>
  );
}
